import { concurrency } from '@farfetched/core';
import { createInstance } from '@leprecoins/effector-query';
import type { OverloadedParameters } from '@leprecoins/utility-types';
import { combine } from 'effector';
import { format } from 'patronum';
import { API_PLATFORM_URL } from 'shared/config';
import { $accessToken } from '../auth';
import { withNotifications } from './http';

const [createBasePlatformQuery, createBasePlatformMutation] = createInstance({
	url: API_PLATFORM_URL,
	headers: combine({
		Authorization: format`Bearer ${$accessToken}`,
	}),
	credentials: 'include',
});

export const createPlatformQuery: typeof createBasePlatformQuery = (
	config: OverloadedParameters<typeof createBasePlatformQuery>[0],
) => {
	const query = createBasePlatformQuery(config);

	concurrency(query, {
		strategy: 'TAKE_LATEST',
	});

	withNotifications(query);

	return query;
};

export const createPlatformMutation: typeof createBasePlatformMutation = (
	config: OverloadedParameters<typeof createBasePlatformMutation>[0],
) => {
	const mutation = createBasePlatformMutation(config);

	withNotifications(mutation);

	return mutation;
};
